export default {
  login: data => ({
    url: `/login`,
    method: 'POST',
    data
  }),
  logout: () => ({
    url: `/logout`,
    method: 'GET'
  }),
  getProfile: () => ({
    url: `/profile`,
    method: 'GET'
  }),
  changePassword: data => ({
    url: `/password`,
    method: 'PUT',
    data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Profile.js